export interface TradeHistoryTrade {
  account_id: ID,
  close_time: MyDate,
  trade_time: MyDate,
  fee: string,
  fee_currency: string,
  id: ID,
  is_maker: boolean,
  open_time: MyDate,
  price: Price,
  quantity: string,
  realized_pnl: string,
  side: 'BUY' | 'SELL',
  sl: string,
  swap: string,
  symbol: string,
  tp: string
}

export interface TradeHistorySummary {
  commission: string,
  pnl: string,
  swap: string
}

export default class TradeHistoryModel {
  constructor(
    public trades: TradeHistoryTrade[],
    public summary: TradeHistorySummary,
    public nextCursor: string | null,
  ) {
  }
}
